import { Component, EventEmitter, OnInit, Output, HostListener, ElementRef , ViewChild, TemplateRef} from '@angular/core';
import {NgbModal, ModalDismissReasons}   from '@ng-bootstrap/ng-bootstrap';
import { NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {HttpClient,HttpClientModule,HttpHeaders,} from '@angular/common/http';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ApidataService } from '../apidata.service';
import { Router, Params, ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-support',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './support.component.html',
  styleUrl: './support.component.css'
})
export class SupportComponent {
  color: string = "black";
  esubText: string = "";
 eSupportText: string = "";
 profile_id = "";
 sendmessage: boolean = false;
 firstName = "";
 lastName = "";
 emailAddress = "";
 dictionaryStatus = "";
 comefromgrammarin;
 comefromsite: boolean = false;
 yesturedic: boolean = true;
  matchTest;
  matchfirst;
  matchlast;
  testingval;

  constructor(private modalService: NgbModal,
    private router: Router,
    private apiservice: ApidataService,
     private http:HttpClient ,
     private route: ActivatedRoute,
    private elementRef: ElementRef,) {}
    doc_id = "";
  ngOnInit() {

    this.openModal();
    this.route.paramMap.subscribe(params => {
      this.doc_id = params.get('doc_id');
  
    
    });
  }
  public ngAfterViewInit(): void {
    this.fetchProfileData();
  }
  @ViewChild('content', { static: true }) content: TemplateRef<any>;
  openModal() {
  
    this.modalService.open(this.content,{ backdrop: 'static', keyboard: false , centered: true,windowClass: 'my-class'});
  }

openModels(content:any, data:any=null){
this.modalService.open(content,{size:"lg"})
}
closeModal(){
  this.modalService.dismissAll();
}

supportSubmission() {
  let form_subject = $("#form_subject").val();
  let form_message = $("#form_message").val();

  if (form_subject === "" || form_message === "") {
    this.color = "red";
    this.eSupportText = "Please provide the required fields";
    $("#eSupportText")
      .html('<i class="fa fa-times-circle me-1"></i> Please provide the required fields')
      .show(); 

    setTimeout(() => {
      $("#eSupportText").hide();
    }, 4000);
  } else {
    this.profile_id = localStorage.getItem("profile_id");

    var newword = "96"; 

    this.apiservice
      .submitSupportForm(
        this.profile_id,
        this.doc_id,
        form_subject,
        form_message,
        this.getBrowserVersion()
      )
      .subscribe((data) => this.handleSupportSubmit(data));
  }
}

handleSupportSubmit(data: Response) {
  this.sendmessage = true;
  this.color = "green";
  this.eSupportText = "Message Sent Successfully";
  $("#eSupportText")
    .html('<i class="fas fa-check-circle me-1"></i> Message Sent Successfully')
    .show();


  $("#form_subject").val("");
  $("#form_message").val("");

  setTimeout(() => {
    $("#eSupportText").hide();
  }, 3000);
}
 LoadProfileData(data: Response) {

    let receivedData = data;
    this.firstName = receivedData["contents"][0][1];
    this.lastName = receivedData["contents"][0][2];
    this.emailAddress = receivedData["contents"][0][0];
    this.dictionaryStatus = receivedData["contents"][0][3];
    this.comefromgrammarin = receivedData["contents"][0][4];
    if (this.comefromgrammarin === "grammarin") {
      this.comefromsite = true;
    }
    if (this.dictionaryStatus == 'off'){
      this.yesturedic = false;
    }
  // }
}
public fetchProfileData() {

  this.profile_id = localStorage.getItem("profile_id");
  this.apiservice
    .getUserProfileContents(this.profile_id)
    .subscribe((data) => this.LoadProfileData(data));
}
getBrowserVersion() {
  var userAgent = navigator.userAgent,
    tem;
  this.matchTest =
    userAgent.match(
      /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i
    ) || [];
  if (/trident/i.test(this.matchTest[1])) {
    tem = /\brv[ :]+(\d+)/g.exec(userAgent) || [];
    return "IE " + (tem[1] || "");
  }
  if (this.matchTest[1] === "Chrome") {
    tem = userAgent.match(/\b(OPR|Edge)\/(\d+)/);
    if (tem != null) return tem.slice(1).join(" ").replace("OPR", "Opera");
  }
  this.matchTest = this.matchTest[2]
    ? [this.matchTest[1], this.matchTest[2]]
    : [navigator.appName, navigator.appVersion, "-?"];

  this.matchfirst = this.matchTest[0];
  this.matchlast = this.matchTest[1];

  if ((tem = userAgent.match(/version\/(\d+)/i)) != null)
    this.matchTest.splice(1, 1, tem[1]);
  return this.matchTest.join(" ");
}

toTitleCase(str: string): string {
  return str.replace(/\b\w/g, (char) => char.toUpperCase());
}


getFullName(): string {
  return `${this.toTitleCase(this.firstName)}`;
}
navigatetohelpcenter(){
  this.router.navigate(['/help-center']);
  this.modalService.dismissAll();
}
}
